module.exports = __webpack_public_path__ + "static/media/JH.30ac8789.svg";